export const CONNECTION_GROUPS_TEXT = {
    id: 'oe.connectionGroups.title',
    description: 'Title text',
    defaultMessage: 'Connection Groups',
};

export const ADD_CONNECTION_GROUP_BTN_TEXT = {
    id: 'oe.connectionGroups.addConnectionGroup',
    description: 'Button label',
    defaultMessage: '+ Add Connection Group',
};

export const ADD_CONNECTION_GROUP_TITLE_TEXT = {
    id: 'oe.connectionGroups.addConnectionGroup',
    description: 'Button label',
    defaultMessage: 'Add Connection Group',
};

export const EDIT_CONNECTION_GROUP_TITLE_TEXT = {
    id: 'oe.connectionGroups.editConnectionGroup',
    description: 'Button label',
    defaultMessage: 'Edit Connection Group',
};

export const CONNECTION_GROUP_CONNECTIONS_LABEL_TEXT = {
    id: 'oe.connectionGroups.connections',
    description: 'Label text',
    defaultMessage: 'Connections',
};

export const NO_CONNECTIONS_ADDED_TEXT = {
    id: 'oe.connectionGroups.noConnectionsAdded',
    description: 'Text',
    defaultMessage: 'No Connections added',
};

export const DELETE_CONNECTION_GROUP_TEXT = {
    id: 'oe.connectionGroups.deleteConnectionGroup',
    description: 'Label text',
    defaultMessage: 'Delete Connection Group',
};

export const DELETE_GROUP_TEXT = {
    id: 'oe.connectionGroups.deleteGroup',
    description: 'Label text',
    defaultMessage: 'Delete Group',
};
